import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import headerTheme from '../../styles/headerTheme';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1v5bp5p-0"
})(["padding-top:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'header.height', headerTheme.header.height));
}, function (_ref2) {
  var isFullHeight = _ref2.isFullHeight;
  return isFullHeight && css(["height:100vh;"]);
});
export default Container;